import {ModalProps} from "react-bootstrap/Modal";
import {Button, Modal} from "react-bootstrap";
import React, {FC, memo, useCallback, useState} from "react";

import cameraIcon
    from "../../image/landscape-mountains-lake-nature-reflection-grass-sky-river-national-park-valley-wilderness-Alps-tree-autumn-leaf-mountain-season-tarn-loch-mountainous-landforms-mountain-range-590185.jpg"
import {ModalContext, ModalHeader, ModalImg} from "./ModalVewImageStyle";
import {ArrowClockwise, ArrowCounterclockwise, Upload} from "react-bootstrap-icons";
import {Trash3} from "react-bootstrap-icons";
import {ICardModel} from "../../store/sliceModal";
import {fetchDeleteFile, fetchRotateIcon, fetchUploadFile} from "../../fetch/FileRequest";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, IRootState} from "../../store/configureStore";
import {actions} from "../../store/sliceModal";
import {IFile} from "../../store/sliceFiles";
import {config} from "../../config";
import {isMobile} from "../../utils/Util";
import {fetchPublicRotateIcon, fetchPublicUploadFile} from "../../fetch/PublicFileRequest";


const ModalVewImage:FC<ModalProps & ICardModel> = (props) => {
    const {id, name, publicPath} = props
    const dispatch = useDispatch<AppDispatch>();

    const file: IFile[] = useSelector((state: IRootState) => state.files?.fileList?.filter((f: IFile) => f?.id == id))

    const deleteHandle = useCallback( (event: React.MouseEvent<HTMLButtonElement>) => {
        fetchDeleteFile(id, false).then(resp => {
            if (resp.status && resp.status < 400) {
                dispatch(actions.closeCardModal())
            }
        })
    },[id])

    const rotateHandle = useCallback( (rotateNumber: number) => {
        if (publicPath?.length > 0) {
            fetchPublicRotateIcon(publicPath, id, rotateNumber)
        } else {
            fetchRotateIcon(id, rotateNumber)
        }

    },[id, publicPath])

    const downloadHandle = useCallback( (event: React.MouseEvent<HTMLButtonElement>) => {
        if (publicPath?.length > 0) {
            fetchPublicUploadFile(publicPath, id,  props.name)
        } else {
            fetchUploadFile(id, props.name)
        }
    },[id])


    return (
        <Modal
            {...props}
            size={"lg"}
            fullscreen
            //    centered
        >
            <ModalHeader closeButton style={{gap: "10px"}}>
                <Button variant={"outline-success"} style={{display: "flex", alignItems: "center"}} onClick={downloadHandle}>
                    <Upload style={{marginRight: "5px"}} size={22} />
                    {isMobile ? '' : 'Загрузить'}
                </Button>
                <Button variant={"outline-danger"} disabled={publicPath?.length != null} style={{display: "flex", alignItems: "center"}} onClick={deleteHandle}>
                    <Trash3 style={{marginRight: "5px"}} size={22}/>
                    {isMobile ? '' : 'Удалить'}
                </Button>
                <Button variant={"outline-success"} style={{display: "flex", alignItems: "center"}} onClick={() => rotateHandle(90)}>
                    <ArrowClockwise style={{marginRight: "5px"}} size={22}/>
                </Button>
                <Button variant={"outline-success"} style={{display: "flex", alignItems: "center"}} onClick={() => rotateHandle(-90)}>
                    <ArrowCounterclockwise style={{marginRight: "5px"}} size={22}/>
                </Button>
            </ModalHeader>
            <Modal.Body>
                <ModalContext>
                    {file.length > 0 && publicPath?.length > 0 && <ModalImg src={`${config.baseurl}/api/public/file/img/${publicPath}/${file[0].icon}`}/>}
                    {file.length > 0 && publicPath?.length == null && <ModalImg src={`${config.baseurl}/api/img/${file[0].icon}`}/>}
                </ModalContext>

            </Modal.Body>
            <Modal.Footer style={{justifyContent: "center"}}>{name}</Modal.Footer>
        </Modal>
    )
        ;
}

export default memo(ModalVewImage)
